<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="stripe-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Stripe Payment</h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img
              class="icon-img text-center"
              src="assets/img/acad-icon.png"
              alt=""
            />
            <br />
            <hr />
            <img
              src="assets/img/visa.png"
              alt=""
              style="width: 60px; height: 20px; margin: 0 auto"
              class="img-fluid text-center"
            />
            <img
              src="assets/img/mastercard.png"
              alt=""
              style="width: 50px; height: 27px; margin: 0 auto"
              class="img-fluid text-center"
            />
          </div>

          <h4 class="mb-2 text-center support-text">
            <div class="mb-2">Stripe Payment</div>
            <br />
            <span style="color: #9d9d9d"> إختر قيمة الشحن</span>
          </h4>
          <!--begin::Input wrapper-->
          <!--begin::Radio group-->
          <div data-kt-buttons="true">
            <div class="row">
              <div v-for="plan in plans" :key="plan.value" class="col-4 mb-3">
                <label
                  style="width: 100%"
                  class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start"
                >
                  <div class="align-items-center">
                    <div
                      class="form-check form-check-custom form-check-solid form-check-primary"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        name="plan"
                        :value="plan.value"
                        v-model="selectedPlan"
                      />
                    </div>
                  </div>
                  <div class="">
                    <span class="fs-1x fw-bold"> {{ plan.text }} </span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <!--end::Radio group-->
          <!--end::Input wrapper-->

          <!--begin::Stripe form-->
          <form id="payment-form" @submit="handleSubmit">
            <div id="card-number-element" dir="ltr" class="mb-3">
              <!-- A Stripe CardNumberElement will be inserted here. -->
            </div>
            <div id="card-expiry-element" class="mb-3" dir="ltr">
              <!-- A Stripe CardExpiryElement will be inserted here. -->
            </div>
            <div id="card-cvc-element" class="mb-3" dir="ltr">
              <!-- A Stripe CardCvcElement will be inserted here. -->
            </div>
            <!-- Used to display form errors. -->
            <div id="card-errors" role="alert"></div>
            <button
              id="submit-button"
              class="btn btn-primary mt-3"
              :disabled="isLoading"
            >
              <span v-if="isLoading">Processing...</span>
              <span v-else>Continue <i class="fa fa-arrow-left"></i></span>
            </button>
            <!-- Loader -->
            <div v-if="isLoading" class="loader"></div>
          </form>
          <!--end::Stripe form-->
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import { loadStripe } from "@stripe/stripe-js";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/stripe-js";

export default {
  name: "StripeAcademia",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      isLoading: false,
      stripe: null,
      elements: null,
      selectedPlan: null,
      cardHolderName: "", // Add cardHolderName to data
      plans: [
        { value: "30000", text: "300 $" }, // Amount in cents
        { value: "20000", text: "200 $" },
        { value: "10000", text: "100 $" },
        { value: "5000", text: "50 $" },
        { value: "2000", text: "20 $" },
        { value: "1000", text: "10 $" },
      ],
    };
  },
  async mounted() {
    $("#stripe-modal").on("show.bs.modal", () => {
      var myModal = new bootstrap.Modal(
        document.getElementById("payments-modal")
      );
      myModal.hide();
    });

    this.stripe = await loadStripe(
      "pk_live_51Kd1hOA8nykJCX5BQUBf6EmPjXP384RZkIVCgYsDEZVL4pGO4siCVxsltHmXRY6UEVikk8ivmvLJ3a1UFZ09pbte00ELA5szaD"
    );

    const appearance = {
      theme: "stripe", // Use the 'stripe' theme as a base
      variables: {
        colorPrimary: "#0570de",
        colorBackground: "#ffffff",
        colorText: "#30313d",
        colorDanger: "#df1b41",
        fontFamily: "Ideal Sans, system-ui, sans-serif",
        spacingUnit: "4px",
        borderRadius: "4px",
        // Customize additional variables as needed
      },
      rules: {
        ".StripeElement": {
          boxShadow:
            "0px 0px 4px rgba(50, 50, 93, 0.1), 0px 2px 5px 0 rgba(50, 50, 93, 0.1)",
          padding: "10px",
        },
      },
    };

    this.elements = this.stripe.elements({ appearance });

    const cardNumberElement = this.elements.create("cardNumber");
    cardNumberElement.mount("#card-number-element");

    const cardExpiryElement = this.elements.create("cardExpiry");
    cardExpiryElement.mount("#card-expiry-element");

    const cardCvcElement = this.elements.create("cardCvc");
    cardCvcElement.mount("#card-cvc-element");

    cardNumberElement.on("change", (event) => {
      const displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });

    cardExpiryElement.on("change", (event) => {
      const displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });

    cardCvcElement.on("change", (event) => {
      const displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });
  },
  methods: {
    async handleSubmit(event) {
      event.preventDefault();
      this.isLoading = true;

      const { token, error } = await this.stripe.createToken(
        this.elements.getElement("cardNumber")
      );

      if (error) {
        const errorElement = document.getElementById("card-errors");
        errorElement.textContent = error.message;
        this.isLoading = false;
      } else {
        const selectedPlan = this.selectedPlan;

        // Send the token, selected plan, and card holder name to Stripe API
        this.academiaCharge(token.id, selectedPlan);
      }
    },
    //sk_test_51Kd1hOA8nykJCX5BPsnFwYPt1sdXd5MLW8JH3ONMDknrovB0t2S3N4YJgxnfstlY9K69L96hkQQE5WHSP7x9zI1x00ptlpCQuY
    //pk_test_51Kd1hOA8nykJCX5BKfGFHQJL9BrpGbq3v8ey9FsHlHimRjVMnn6CNczWEObnSu2DvaSIJeM1EhV7mbTzFevc4oYy00fTGim7Sn
    async academiaCharge(token, plan) {
      try {
        const response = await fetch("https://api.stripe.com/v1/charges", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer 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`, // Use the provided secret key
          },
          body: new URLSearchParams({
            amount: plan, // Plan value as amount in cents
            currency: "usd",
            source: token,
          }),
        });

        const result = await response.json();

        if (response.ok) {
          console.log("Payment is success");
          console.log(result);

          // Call the specified endpoint with the transaction ID
          await this.sendTransactionId(result.id);
        } else {
          Swal.fire({
            icon: "error",
            title: "Payment Failed",
            text: result.error.message,
          });
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          icon: "error",
          title: "Payment Failed",
          text: error.message,
        });
        this.isLoading = false;
      }
    },
    async sendTransactionId(transactionId) {
      try {
        const response = await fetch(apiUrl + "/e-payment/stripe", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`, // Use the token stored in local storage
          },
          body: JSON.stringify({
            transaction_id: transactionId,
          }),
        });
        if (response.ok) {
          this.isLoading = false;

          Swal.fire({
            icon: "success",
            title: "تم شحن المحفظة بنجاح",
            text: "",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        } else if (!response.ok) {
          this.isLoading = false;

          const result = await response.json();
          Swal.fire({
            icon: "error",
            title: "Failed to send transaction ID",
            text: result.message,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Failed to send transaction ID",
          text: error.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 100px;
}

.btn-outline-dashed {
  border: 1px dashed #ddd;
}

#card-number-element,
#card-expiry-element,
#card-cvc-element {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 10px;
}

#card-errors {
  color: red;
  margin-top: 10px;
}

.loader {
  border: 4px solid rgba(0, 0, 0, 0.1); /* Light grey */
  border-left: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
